(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    const GrizzlyHeaderDrawer = customElements.get('header-drawer');

  if (GrizzlyHeaderDrawer && !GrizzlyHeaderDrawer.prototype.grizzlyDropdownPatched) {
    const originalOpenMenuDrawer = GrizzlyHeaderDrawer.prototype.openMenuDrawer;
    const originalCloseMenuDrawer = GrizzlyHeaderDrawer.prototype.closeMenuDrawer;

    GrizzlyHeaderDrawer.prototype.openMenuDrawer = function (summaryElement) {
      if (this.dataset.layout !== 'dropdown') {
        return originalOpenMenuDrawer.call(this, summaryElement);
      }

      this.header = this.header || document.querySelector('.section-header');
      this.borderOffset =
        this.borderOffset || (this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0);
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
      this.header.classList.add('menu-open');

      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });

      summaryElement.setAttribute('aria-expanded', true);
      window.addEventListener('resize', this.onResize);
    };

    GrizzlyHeaderDrawer.prototype.closeMenuDrawer = function (event, elementToFocus) {
      const isDropdown = this.dataset.layout === 'dropdown';
      const result = originalCloseMenuDrawer.call(this, event, elementToFocus);

      if (isDropdown && elementToFocus && this.dropdownMenu) {
        this.dropdownMenu.querySelectorAll('details').forEach((details) => {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        });
        this.dropdownMenu.querySelectorAll('.gc-mobile-menu__group > summary').forEach((summary) => {
          summary.setAttribute('aria-expanded', 'false');
        });
      }

      return result;
    };

    GrizzlyHeaderDrawer.prototype.grizzlyDropdownPatched = true;
  }

  function initializeGrizzlyHeaderDropdowns(scope = document) {
    scope.querySelectorAll("header-drawer[data-layout='dropdown']").forEach((drawer) => {
      if (drawer.dataset.dropdownReady === 'true') return;

      const details = drawer.querySelector(':scope > details');
      const menu = details?.querySelector(':scope > .menu-drawer');
      const section = drawer.closest('.section-header');
      const headerWrapper = drawer.closest('.header-wrapper');

      if (!details || !menu || !section || !headerWrapper) return;

      drawer.dataset.dropdownReady = 'true';
      drawer.dropdownMenu = menu;
      menu.dataset.gcDropdownPanel = 'true';
      section.insertAdjacentElement('afterend', menu);
    });
  }

  initializeGrizzlyHeaderDropdowns();
  document.addEventListener('shopify:section:load', (event) => initializeGrizzlyHeaderDropdowns(event.target));
  } catch(e) { console.error(e); }
})();

})();
